import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import {
  joinMultiValueFilters,
  listQueryToApiParams,
} from '#/utils/listUrl/parseListSearchParams';

/**
 * 報修單列表。
 * Query：`keyword`、`repair_request_no`、`status`、`repair_request_date_from`／`_to`、
 * `remark`、`customer_name`、`sort`（snake 白名單）、`page`、`page_size`。
 *
 * @param {object} listQuery
 */
export async function fetchRepairRequestList(listQuery) {
  const { data: raw } = await request.get('/aftersales/repair-request', {
    params: listQueryToApiParams(joinMultiValueFilters(listQuery)),
  });
  return parseVer4ListResponse(raw);
}
